import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "text", "lessControl", "moreControl"]

  connect() {
    this.collapsedHeight = 180
    this.heightMargin = 28
    this.speed = 575

    const naturalHeight = this.textTarget.scrollHeight

    this.isTruncatable = naturalHeight > this.collapsedHeight + this.heightMargin

    if (!this.isTruncatable) {
      return
    }

    this.expanded = false
    this.textTarget.style.overflow = 'hidden'
    this.textTarget.style.transition = `height ${this.speed}ms`
    this.textTarget.style.height = `${this.collapsedHeight}px`

    this.moreControlTarget.classList.remove('hide')
  }

  disconnect() {
    if (!this.isTruncatable) {
      return
    }

    if (this.hasTextTarget) {
      this.textTarget.style.overflow = ''
      this.textTarget.style.transition = ''
      this.textTarget.style.height = ''
    }

    if (this.hasMoreControlTarget) {
      this.moreControlTarget.classList.add('hide')
    }

    if (this.hasLessControlTarget) {
      this.lessControlTarget.classList.add('hide')
    }
  }

  toggle(event) {
    if (event) {
      event.preventDefault()
    }

    if (!this.isTruncatable) {
      return
    }

    if (this.expanded) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    this.expanded = true
    this.textTarget.style.height = `${this.textTarget.scrollHeight}px`
    this.moreControlTarget.classList.add('hide')
    this.lessControlTarget.classList.remove('hide')
  }

  collapse() {
    this.expanded = false
    this.textTarget.style.height = `${this.collapsedHeight}px`
    this.lessControlTarget.classList.add('hide')
    this.moreControlTarget.classList.remove('hide')
  }
}
